import React, { Component } from 'react'
import { Table, InputNumber } from 'antd'

class GoodsSpecsTable extends Component {
  constructor (props) {
    super(props)
    this.state = {
      expandeValue: {} // [{id, value}]
    }
  }

   expandedColumns = () => ([
     {
       title: '商品规格',
       dataIndex: 'specificationsName',
       key: 'specificationsName'
     },

     {
       title: '出售价（元）',
       dataIndex: 'salePrice',
       key: 'salePrice',
       render: item => (item / 100).toFixed(2),
     },
     {
       title: '原价（元）',
       dataIndex: 'originalPrice',
       key: 'originalPrice',
       render: item => (item / 100).toFixed(2),
     },
     {
       title: '底价（元）',
       dataIndex: 'floorPrice',
       key: 'floorPrice',
       render: item => (item / 100).toFixed(2),
     },
    
     {
       title: '商品库存',
       dataIndex: 'number',
       key: 'number'
     },
     {
       title: '商品销量',
       dataIndex: 'volume',
       key: 'volume',
       render: item => item || 0,
     },
     {
       title: '商品佣金（元）',
       dataIndex: 'commission',
       key: 'commission',
       render: (value, record) =>{
         const { model } = this.props
         value = (value / 100).toFixed(2)
         if (model === 'edite') {
           return (<InputNumber min={0} defaultValue = {value} onChange = {(v)=>{ this.handleChange(`id_${record.id}`, record.id, v) }} />)
         }
         else {
           return <span>{value || 0}</span>
         }
       }
       
     }
   ])
   handleChange = (key, id, value) => {
     this.setState((preState)=>({
       expandeValue: {...preState.expandeValue, [key]: {id, commission: value*100} }
     }), ()=>{
       const { onInputs } = this.props
       onInputs(this.state.expandeValue)
     })
   }
   render () {
     const { param: {goodSpecifications} } = this.props
     const dataList = goodSpecifications.map(item=>{
       /**
           * salePrice:商品出售价
           * originalPrice:商品原价
           * floorPrice:商品底价
           */
       const { salePrice, originalPrice, floorPrice } = item
       let price = { salePrice, originalPrice, floorPrice }
       return {...item, price, key: item.id}
     })
     return (
       <Table bordered
         size = "small"
         // rowSelection={rowSelection} 
         columns={this.expandedColumns()}
         dataSource={dataList}
         pagination = {false}
       />)
   }
}

export default GoodsSpecsTable
GoodsSpecsTable.defaultProps = {
  model: 'watch'
}